// src/constants/date/date.ts
var DUTCH_ABBREV_MONTHS = [4, 5, 6];

export {
  DUTCH_ABBREV_MONTHS
};
